import { SET_TRAINER_SEARCH, SET_TRAINER, SET_TRAINERS, SET_TRAINER_ATTRIBUTES} from '../../actions/types/types';

const initState = {
  trainers: [],
  count:0,
  trainer: {}, // shuold be true later on but for now keep it false
  trainerAttributes:[],
  home_search:""
};

const TrainerReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_TRAINERS:
      return {
        ...state,
        trainers: action.payload.data,
        count: action.payload.count
      };
    case SET_TRAINER:
      return { ...state, trainer: action.payload.data };
    case SET_TRAINER_ATTRIBUTES:
    return { ...state, trainerAttributes: action.payload.data };
    case SET_TRAINER_SEARCH:
      return {
        ...state,
        home_search: action.payload.data,
      };
    default:
      return { ...state };
  }
};

export default TrainerReducer;
